import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Input,
  Col,
  Row,
  Container,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from "reactstrap";
import api from "../../api";
import "./index.css";
import Loading from "../../components/Loading";
import { UserInfo } from "model/user";


export default function Monitoring() {
  const [currentUser, setCurrentUser] = useState<UserInfo | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  // permissions
  const roleAccessAdvancedFeatures = ["Admin", "Company Admin", "Data Practitioner"];
  const canAccessAdvancedFeatures = currentUser?.roles.some(userRole => roleAccessAdvancedFeatures.includes(userRole.name));

  const initData = async () => {
    const user = api.getCurrentUser();
    setCurrentUser(user);
    setLoading(false);
  };

  useEffect(() => {
    initData();
  }, []);

  if (loading) return <Loading />;

  return (
    <Container>
      {canAccessAdvancedFeatures &&
        <Row>
          <Col
            xs={12}
            md={4}
            tag={Link}
            to="/monitoring/alerting"
            style={styles.block}
          >
            <div style={styles.item}>
              <i className="material-icons" style={styles.icon}>
                  campaign
              </i>
              <Label style={styles.title}>Alerting</Label>
            </div>
          </Col>
          <Col
          xs={12}
          md={4}
          tag={Link}
          to="/monitoring/dashboard"
          style={styles.block}
          >
          <div style={styles.item}>
              <i className="material-icons" style={styles.icon}>
              insert_chart_outlined
              </i>
              <Label style={styles.title}>Dashboard</Label>
          </div>
          </Col>
        </Row>
      }
    </Container>
  );
}

const styles: { [name: string]: React.CSSProperties } = {
  block: {
    marginTop: 20,
  },
  item: {
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "var(--color-accent-dark)",
    borderRadius: 5,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 25,
    paddingBottom: 25,
  },
  title: {
    marginTop: 15,
    fontWeight: 1000,
    fontSize: 20,
    color: "var(--color-accent-dark)",
  },
  icon: {
    fontSize: 36,
    color: "var(--color-accent-dark)",
  },
};
